import { useState, useEffect, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation, useHistory } from "react-router-dom";
import Repo from "../../Utility/Repo";
import SelectComponent from "../../Components/SelectComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditTicket(props) {
  const apiToken = useContext(TokenContext);
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [user, setUser] = useState(false);
  const query = useQuery();
  const history = useHistory();

  const ticketId = query.get("id");
  const userId = query.get("userId");
  useEffect(() => {
    if (!ticketId && !userId) {
      setTicket({
        userId: "",
        richiedente: "",
        categoria: "",
        dettagli: "",
        assegnatoA: "",
      });
      setIsEdit(false);
      setLoading(false);
      return;
    }

    setLoading(true); // Aggiungi il loading prima di iniziare a caricare i dati

    if (ticketId) {
      Repo.getTicket(apiToken, ticketId)
        .then((response) => {
          setTicket(response.data);
          setIsEdit(true);
        })
        .catch((error) => console.error("Errore nel recupero ticket:", error))
        .finally(() => setLoading(false));
    } else if (userId) {
      Repo.getUserOp(apiToken, userId)
        .then((response) => {
          setUser(response.data);
          console.log("response.data", response.data);
          const user = response.data;
          setTicket({
            userId: user.id || "",
            richiedente: user.firstName + " " + user.lastName,
            categoria: "",
            dettagli: "",
            assegnatoA: "",
          });
          setIsEdit(false);
        })
        .catch((error) => {
          console.error("Errore nel recupero dell'operatore:", error);
          setTicket({
            userId: "",
            richiedente: "",
            categoria: "",
            dettagli: "",
            assegnatoA: "",
          });
          setIsEdit(false);
        })
        .finally(() => setLoading(false)); // Imposta lo stato di loading in caso di errore
    }
  }, [apiToken, query.get("id"), query.get("userId")]); // Dipendenze limitate ai valori effettivi

  const ticketStati = [
    { value: 0, label: "Aperto" },
    { value: 1, label: "In Corso" },
    { value: 2, label: "Risolto" },
    { value: 3, label: "Chiuso" },
  ];

  const handleSubmit = () => {
    if (isEdit) {
      Repo.modificaTicket(apiToken, ticketId, ticket)
        .then(
          () =>
            (window.location.href =
              props.subfolder +
              "/lista_utenti/dati_utente/ticket?userId=" +
              ticket.userId)
        )
        .catch((error) => console.error("Errore aggiornamento ticket:", error));
    } else {
      Repo.postTicket(apiToken, ticket)
        .then(
          () =>
            (window.location.href =
              props.subfolder +
              "/lista_utenti/dati_utente/ticket?userId=" +
              userId)
        )
        .catch((error) => console.error("Errore inserimento ticket:", error));
    }
  };

  if (loading) return <Loader />;

  return (
    <div>
      <h1>{isEdit ? "Modifica Ticket" : "Nuovo Ticket"}</h1>
      <div className="row">
        <div className="col-lg-12 mt-3 text-right">
          <p>
            Assegnato: <strong>{ticket.assegnatoA}</strong>
          </p>
        </div>

        <div className="col-lg-4">
          <Input
            label="Richiedente"
            value={ticket.richiedente}
            onChange={(e) =>
              setTicket({ ...ticket, richiedente: e.target.value })
            }
            readOnly={isEdit}
          />
        </div>
        <div className="col-lg-4">
          <Input
            label="Categoria"
            value={ticket.categoria}
            readOnly={ticket.stato === 2 || ticket.stato === 3}
            onChange={(e) =>
              setTicket({ ...ticket, categoria: e.target.value })
            }
          />
        </div>
        <div className="col-lg-4">
          {ticket.stato === 2 || ticket.stato === 3 ? (
            <span>
              {ticketStati.find((s) => s.value === ticket.stato)?.label ||
                "Stato sconosciuto"}
            </span>
          ) : (
            <SelectComponent
              options={ticketStati}
              value={ticket && ticket.stato !== undefined ? ticket.stato : null}
              onChange={(e) =>
                setTicket({ ...ticket, stato: parseInt(e.value, 10) })
              }
              placeholder="Seleziona stato"
              isDisabled={!isEdit}
              validation={true}
              columnClass="col-12"
            />
          )}
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-12">
          <label htmlFor="descrizione">Descrizione:</label>
          <textarea
            id="descrizione"
            name="descrizione"
            value={ticket.dettagli}
            readOnly={ticket.stato === 2 || ticket.stato === 3}
            onChange={(e) => setTicket({ ...ticket, dettagli: e.target.value })}
          ></textarea>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-lg-6 text-left">
          <button
            className="btn btn-outline-secondary"
            onClick={() => history.goBack()}
          >
            Indietro
          </button>
        </div>
        <div className="col-lg-6 text-right">
          <button className="btn btn-primary" onClick={handleSubmit}>
            {isEdit ? "Salva Modifiche" : "Crea Ticket"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditTicket;
